import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EAssetVisibilityActionsText = {
	all: 'All',
	allFiltered: 'All filtered',
	currentPage: 'Current page',
	selectedOnCurrentPage: 'Selected on current page',
} as const;

export type TAssetVisibilityActionsText = TValueOfStringRecord<typeof EAssetVisibilityActionsText>

export const EAssetVisibilityActions = {
	showAll: 'showAll',
	showAllFiltered: 'showAllFiltered',
	showSelected: 'showSelected',
	showCurrentPage: 'showCurrentPage',
	hideAll: 'hideAll',
	hideSelected: 'hideSelected',
	hideCurrentPage: 'hideCurrentPage',
	hideAllFiltered: 'hideAllFiltered',
} as const;

export type TAssetVisibilityActions = TValueOfStringRecord<typeof EAssetVisibilityActions>

export const AssetVisibilityActionsOptions = [
	{
		label: 'Show on the map',
		name: 'show',
		items: [
			{
				text: EAssetVisibilityActionsText.selectedOnCurrentPage,
				id: EAssetVisibilityActions.showSelected,
				disabled: false,
			},
			{
				text: EAssetVisibilityActionsText.currentPage,
				id: EAssetVisibilityActions.showCurrentPage,
				disabled: false,
			},
			{
				text: EAssetVisibilityActionsText.allFiltered,
				id: EAssetVisibilityActions.showAllFiltered,
				disabled: false,
			},
			{
				text: EAssetVisibilityActionsText.all,
				id: EAssetVisibilityActions.showAll,
				disabled: false,
			},
		],
	},
	{
		label: 'Hide on the map',
		name: 'hide',
		items: [
			{
				text: EAssetVisibilityActionsText.selectedOnCurrentPage,
				id: EAssetVisibilityActions.hideSelected,
				disabled: false,
			},
			{
				text: EAssetVisibilityActionsText.currentPage,
				id: EAssetVisibilityActions.hideCurrentPage,
				disabled: false,
			},
			{
				text: EAssetVisibilityActionsText.allFiltered,
				id: EAssetVisibilityActions.hideAllFiltered,
				disabled: false,
			},
			{
				text: EAssetVisibilityActionsText.all,
				id: EAssetVisibilityActions.hideAll,
				disabled: false,
			},
		],
	},
];
